<template>
	<div @click="openMenu">
		<v-menu
			:close-on-content-click="false"
			transition="scale-transition"
			offset-y
			min-width="auto"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-combobox
					v-model="selectedDatesLocal"
					multiple
					:label="labelTextFiled"
					:disabled="disabled"
					:hint="hintLocal"
					persistent-hint
					prepend-icon="mdi-calendar"
					v-bind="attrs"
					v-on="on"
					readonly
				/>
			</template>
				<v-date-picker
					v-model="selectedDatesLocal"
					multiple
					no-title
					scrollable
					:first-day-of-week="1"
				/>
		</v-menu>
	</div>
</template>

<script>
export default {
	name: 'DatePickerMultiple',
	props: {
		labelTextFiled: {
			type: String,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		hint: {
			type: String,
			default: '',
			required: false,
		},
	},
	data() {
		return {
			selectedDatesLocal: [],
			menu: false,
			dates: [],
			hintLocal: this.hint,
			txt: {
				cancel: 'Cancel',
				ok: 'Save selection',
			},
		}
	},
	watch: {
		selectedDatesLocal: {
			handler() {
				this.emitTheDate()
			},
		},
		hint: {
			handler(value) { this.hintLocal = value },
		},
	},
	methods: {
		emitTheDate() {
			this.$emit('emitDates', this.selectedDatesLocal)
		},
		openMenu() {
			this.menu = true
		},
	},
}
</script>

<style lang="scss" scoped>

</style>
